import * as React from 'react';
import { connect } from 'react-redux';
import { redirectToUrl } from '../actions/sspActions';

class RedirectPortal extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = { redirect: false };
    }

    async componentDidMount() {
        let redirect = !this.props.match.url.toLowerCase().includes("/payment/");
        if (redirect) {
            this.props.dispatchAction(redirectToUrl(this.props.ssp.portalRedirectUrl));
        }
        this.setState({ redirect });
    }

    public render() {
        return (
            <>
                {this.state.redirect &&
                    <div>
                        Please wait while we redirect you...
                    </div>
                }
            </>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        ssp: state.ssp,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RedirectPortal);